import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);
export default function Nft1()
{
  return (
    <section id="nfts" className="home-nft" >
      <div className="sc-wrap">
        <div className="bg__color"></div>
        <div className="container ">
          <header className="sc-header text-center wow fadeInLeft">
            {/* <div className="block_100 hidden_md hidden_xl"></div> */}
            <h3 className=" wow fadeInUp" ><span>ROX WALLETS</span> <br></br> Crypto Roc Wallets explained</h3>

          </header>
          <div className="sc-content wow fadeInUp">
            <div className="left">
              <div className="img_ bg_contain"></div>
            </div>
            <div className="right">
              <div className="block_50  "></div>
              <h4>
                Easy setup</h4>
              <p>In short, a crypto wallet is a tool that you can use to interact with a blockchain network. There are various crypto wallet types, which can be divided into three groups: software, hardware, and paper wallets. Depending on their working mechanisms, they may also be referred to as hot or cold wallets </p>
              <div className="block_50  hidden_des "></div>
              <div className="block_10 "></div>
              <div className="btn_w">
                <button className="reset_btn   " ><div className="img_ appstore bg_contain"></div></button>
                <button className="reset_btn   " ><div className="img_ ggplay bg_contain"></div></button>
              </div>
            </div>

          </div>
        </div>
      </div >

    </section >
  );
}
